import { render, staticRenderFns } from "./category-card-pack-catalogue.vue?vue&type=template&id=b1b89612&scoped=true"
import script from "./category-card-pack-catalogue.vue?vue&type=script&lang=js"
export * from "./category-card-pack-catalogue.vue?vue&type=script&lang=js"
import style0 from "./category-card-pack-catalogue.vue?vue&type=style&index=0&id=b1b89612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b89612",
  null
  
)

export default component.exports